import { query } from '@/services/graphql';
import * as operations from './operations';

export default {
  getChapterList(variables = {}) {
    return query(operations.CHAPTER_LIST, variables, true);
  },
  getSectionList(variables = {}) {
    return query(operations.SECTION_LIST, variables, true);
  },
  getExamList(variables = {}) {
    return query(operations.EXAM_LIST, variables, true);
  },
  getParallelExamList(variables = {}) {
    return query(operations.PARALLEL_EXAM_LIST, variables, true);
  },
  getCourseData(variables = {}) {
    return query(operations.LEARN_DATA, variables, true);
  },
  submitCourseResult(variables = {}) {
    return query(operations.SUBMIT, variables, true);
  },
};
